import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/numTwinsList',
      name: 'numTwinsList',
      component: () => import('@/pages/numTwinsList.vue')
    },
    {
      path: '/doctorList',
      name: "doctorList",
      component: () => import("@/pages/doctorList.vue")
    },
    {
      path: '/test',
      name: "test",
      component: () => import("@/pages/test.vue")
    },
    {
      path: '/AppInfo',
      name: "AppInfo",
      component: () => import("@/pages/AppInfo.vue")
    },
    {
      path: '/PlatformInfo',
      name: "PlatformInfo",
      component: () => import("@/pages/PlatformInfo.vue")
    },
    {
      path: '/historyExperience',
      name: "historyExperience",
      component: () => import("@/pages/historyExperience.vue")
    },
    {
      path: '/cheReport',
      name: "cheReport",
      component: () => import("@/pages/cheReport.vue")
    },
    {
      path: '/rpsReport',
      name: "rpsReport",
      component: () => import("@/pages/rpsReport.vue")
    },
    {
      path: '/masReport',
      name: "masReport",
      component: () => import("@/pages/masReport.vue")
    },
    {
      path: '/oneRepair',
      name: "oneRepair",
      component: () => import("@/pages/oneRepair.vue")
    },
    {
      path: '/orderDetail',    //工单详情
      name: "orderDetail",
      component: () => import("@/pages/orderDetail.vue"),
      meta: {
        title: '工单详情'
      }
    },
    {
      path: '/maintList',    //维保详情
      name: "maintList",
      component: () => import("@/pages/maintList.vue"),
      meta: {
        title: '维保'
      }
    },
    {
      path: '/maintInfo',    //维保内容
      name: "maintInfo",
      component: () => import("@/pages/maintInfo.vue"),
      meta: {
        title: '维保内容'
      }
    },
    {
      path: '/repairDetail',    //维修详情
      name: "repairDetail",
      component: () => import("@/pages/repairDetail.vue"),
      meta: {
        title: '工单详情'
      }
    },
    {
      path: '/checkDetail',    //巡检详情
      name: "checkDetail",
      component: () => import("@/pages/checkDetail.vue"),
      meta: {
        title: '巡检详情'
      }
    },
    {
      path: '/log/:logList',    //巡检详情
      name: "log",
      component: () => import("@/pages/log.vue"),
      meta: {
        title: '日志详情'
      }
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js